import { Checkbox, Col, Input, InputNumber, Row, Slider, Spin, Tabs } from 'antd';
import { Component } from "react";
import cookie from "react-cookies";
import { connect } from 'react-redux';
import { error_manager } from "../../../helper/error_manager";
import { get, post } from "../../../helper/request";
import { updateCountSlotWise } from '../../../redux_actions/bloodConfig.action';
import {
    updateDisplaySettings,
    updateDisplaySettingsList,
    updateSettings,
    updateDefaultStainSettings
} from "../../../redux_actions/gamma.state.action";
import { setScanSpeed, setScanProfile, changeSpecimenType } from "../../../redux_actions/preview_status.action";
import { DisplaySettingType, scanSpeed, scanTypeVals, specimenType } from '../../../utils/const';
import {getSupportedSpecimenType, isSuperuser} from "../../../utils/utils";
import { SettingsKeys } from "../../gammaviewer/keys/Settings";
import {
    getAutoExportPanel,
    getCanvasComponentNew,
    getSpeedPanel,
    getStainChooser,
    getVerticalBrushPanel,
    getViewerSettingDropdown,
    getNameFromId, getIdFromName,
    getRecentlyUsedSettings,
    fetchAllDisplaySettings,
    fetchAllStainSettings
} from "../slot_component_utils";
import _ from 'lodash';
import { aclPermissions, hasPermissions } from 'const/ACLPermissions';

const {TabPane} = Tabs;

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BM': specimenType.BM,
    'BLOOD': specimenType.BLOOD,
    'AUTO': specimenType.AUTO
}

class GeneralPreviewSettingsComp extends Component {
    constructor(props) {
        super(props);
        this.state = this.initState();
        this.updateDisplaySetting = updateDisplaySettings;
        this.is_superuser = isSuperuser();
    }

    initState = () => {
        this.slideKey = "display_setting";
        this.settingKeys = SettingsKeys;
        return {
            scanType: this.props.preview.speed === scanSpeed.ZSTACK ? scanTypeVals.Z_STACK : scanTypeVals.WSI,
            wbcCount:100,
        };
    }

    addAllStainSettings() {
        fetchAllStainSettings(SPECIMEN)
            .then(settings => {
                let stainSetting = settings.reduce((settings, setting) => Object.assign(settings, {
                    [setting.stain_name]: setting,
                }), {})
                this.props.dispatch(updateDefaultStainSettings(stainSetting));
                this.setState({
                    stainFetching: false,
                })
                let id = this.props.defaultStainSettings[this.props.preview.specimenType]["default_setting"]
                if (this.props.preview.scanningProfile !== ""){
                    id = this.props.preview.scanningProfile;
                }
                this.changeScanningProfile(id)
            })
            .catch(error => error_manager("Failed to fetch Stain settings", error))
            // }).catch(error => error_manager("Failed to fetch Stain settings", error))
    }


    componentDidUpdate = (prevProps) => {
        if (prevProps.preview.specimenType !== this.props.preview.specimenType && !_.isEmpty(this.props.defaultStainSettings)){
            let id = this.props.defaultStainSettings[this.props.preview.specimenType]["default_setting"];
            let name = getNameFromId(this.props.displaySettingsList, id)
            this.props.dispatch(updateSettings(name));
            this.props.dispatch(setScanProfile(this.props.id, id))
        }

        if ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold !== true) {
            let supportedSpecs = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes
            SPECIMEN = getSupportedSpecimenType(SPECIMEN, supportedSpecs, true);
        }
    }

    componentDidMount = () => {
            this.addAllDisplaySettings();          
            if(((this.props.bloodConfig||{}).countWBCSlotWise||{})[this.props.id]){
            this.setState({
                wbcCount: ((this.props.bloodConfig || {}).countWBCSlotWise || {})[this.props.id]
            })
        }
    }

    addAllDisplaySettings = () =>
        fetchAllDisplaySettings()
            .then((settings) => {
                let dispSetting =
                        settings.reduce((settings, setting) => Object.assign(settings, {
                            [setting.id]: setting,
                        }), {})
                this.props.dispatch(updateDisplaySettingsList(dispSetting))
                if ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold === true) {
                    this.props.dispatch(changeSpecimenType(this.props.device_id, this.props.id, specimenType.AUTO));
                }
                this.addAllStainSettings()
            })
            .catch((error) => error_manager("Failed to fetch display settings", error))

    setWBCCount = (count) => {
        this.setState({
            wbcCount: count,
        })
        this.props.dispatch(updateCountSlotWise([this.props.id, count]));
    }

    changeScanType = (key) => {
        if (key === scanTypeVals.Z_STACK) {
            this.props.onScanSpeedChangeStack();
        } else {
            this.props.dispatch(setScanSpeed(this.props.id, scanSpeed.MEDIUM));
        }
        this.setState({
            scanType: key,
        });
    }

    changeScanningProfile = (value) => {
        let scanningProfile = this.props.displaySettingsList[value];
        this.props.dispatch(updateSettings(scanningProfile.name));
        this.props.dispatch(setScanProfile(this.props.id, scanningProfile.id));
        this.changeDefaultForStain(scanningProfile.id)
    }

    changeDefaultForStain = (id) => {
        if ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold !== true){
            let stainSetting = this.props.defaultStainSettings;
            stainSetting[this.props.preview?.specimenType].default_setting = id
            this.props.dispatch(updateDefaultStainSettings(stainSetting)); 
        }
    }
    

    render() {
        return (
            <div>
                <Row style={{height: '100%', paddingTop: "10px"}}>
                    <Col span={20}>
                        <Row>
                            {getCanvasComponentNew(this.props.status, this.props.previewCanvasRef, this.props.thresholdCanvasRef,
                                this.props.brushEraserPrevCanvasRef, this.props.regions, this.props.onCanvasUpdate, this.props.allowPainting, this.props.startPainting, this.props.paintCanvas,
                                this.props.stopPainting, this.props.dropDistanceCanvas, this.props.dropDistanceCanvasRef, this.props.focusPointsCanvas,
                                this.props.focusPointsCanvasRef, this.props.preview, this.props.id, this.props.device_id, this.props.brushType,
                                this.props.showBrushOrEraserSize)}
                        </Row>
                        <br/>
                        <Row>
                            <Col className="selected-area-component">
                                Selected Area : {this.props.regionArea} mm2
                            </Col>
                        </Row>
                    </Col>
                    <Col span={4}>
                        {getVerticalBrushPanel(this.props.brushType, this.props.brushSize, this.props.changeBrushType, this.props.movedBrushSizeSlider, this.props.brushShape, this.props.changeBrushShape)}
                        <Row className="side-panel-section">
                            <Col>
                                <span className="arial-font"
                                      style={{marginRight: 10, fontSize: 13}}><b>Slide Name</b></span>
                                <Spin spinning={this.props.reading_barcode} tip="Trying to Read Barcode...">
                                    <Input value={this.props.preview.slideName} spellCheck={false} autoComplete="off"
                                           placeholder={this.props.preview.response.slideName}
                                           style={{width: 260}} onChange={this.props.onScanNameChange}/>
                                </Spin>
                            </Col>
                        </Row>
                        <Row className="side-panel-section">
                            <Col span={23}>
                                {(((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold !== true ?
                                getStainChooser(this.props.onSpecimenTypeChange, this.props.preview, Object.keys(SPECIMEN)) :
                                getRecentlyUsedSettings(this.props.displaySettingsList, this.props.displaySettings, this.changeScanningProfile)}
                                {getViewerSettingDropdown(this.props.preview?.specimenType, this.props.displaySettings, this.props.displaySettingsList, this.changeScanningProfile, true)}
                            </Col>
                        </Row>
                        {(((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold === true ? 
                        <Row className="arial-font full-width" style={{fontSize: 13}}>
                            <Row style={{fontWeight:"bold"}}>Select Threshold Level</Row>
                            <Row>
                                <Col>
                                    <Slider onChange={this.props.onAutoThreshLevelChange} 
                                        value={this.props.preview.autoThresholdLevel}
                                        min={this.props.preview.response.threshLevelResult.start} 
                                        max={this.props.preview.response.threshLevelResult.end-1}/>
                                </Col>
                            </Row>
                        </Row>
                        : null
                        }
                            <Row className="side-panel-section">
                                <Col span={24}>
                                    {
                                        getAutoExportPanel(this.props.preview, this.props.toggleExporting, this.props.autoExport)
                                    }
                                    {this.is_superuser ?
                                        <>
                                    <Row style={{fontSize:13}}>
                                        <Col span={24}>
                                            <Checkbox checked={this.props.preview.doTilingOnly}
                                                      onClick={this.props.toggleTiling}>
                                                Do Tiling Only
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row style={{fontSize: 13}}>
                                        <Col span={24}>
                                            <Checkbox checked={this.props.preview.doTilingAfterScan}
                                                      onClick={this.props.toggleTilingAfterScan}>
                                                Do Tiling After Scan
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                        </>:
                                    null}
                                </Col>
                            </Row>
                        <Row className="side-panel-section">
                            {this.props.preview.specimenType === specimenType.BM ?
                                <Tabs activeKey={this.state.scanType} size="small">
                                    {/* onChange={this.changeScanType} */}
                                    <TabPane tab="WSI" key={scanTypeVals.WSI}>

                                        {/* TODO: Implement WBC Count number */}
                                        <Col>
                                     <span><b># WBC: </b>
                                         <InputNumber min={1} max={5000} value={this.state.wbcCount}
                                                      onChange={this.setWBCCount}/>
                                     </span>
                                        </Col>
                                    </TabPane>
                                </Tabs> :
                                <Tabs activeKey={this.state.scanType} onChange={this.changeScanType} size="small">
                                    <TabPane tab="WSI" key={scanTypeVals.WSI}>
                                        This will take a normal scan.
                                        <Col>
                                            {
                                                getSpeedPanel(this.props.onScanSpeedChange, this.props.preview)
                                            }
                                        </Col>
                                        <br></br>
                                        <Col>{
                                            (this.props.preview || {}).speed === scanSpeed.FAST ? "Mostly Flat Tissue." :
                                                (this.props.preview || {}).speed === scanSpeed.MEDIUM ? "Some Artifacts." : "Very Heavy Artifacts. Can Have Folds"}</Col>
                                    </TabPane>
                                    {hasPermissions([aclPermissions.take_z_scans]) ?
                                        <TabPane tab="Z Scan" key={scanTypeVals.Z_STACK}>
                                            <Row key={0} style={{padding: 10}}>
                                                <Row style={{fontSize: 13}}>
                                                    <Col span={10} className="z-stack-scan-text">
                                                        Z Stack Levels
                                                    </Col>
                                                    <Col span={14}>
                                                        <Input className="z-stack-scan-input-field"
                                                               value={this.props.preview.zStackLevels}
                                                               placeholder={10} onChange={this.props.onZLevelsChange}/>
                                                    </Col>
                                                </Row>
                                                <Row style={{fontSize: 13}}>
                                                    <Col span={10} className="z-stack-scan-text">
                                                        Step Size (um)
                                                    </Col>
                                                    <Col span={14}>
                                                        <Input className="z-stack-scan-input-field"
                                                               value={this.props.preview.stepSize}
                                                               placeholder={0.5}
                                                               onChange={this.props.onStepSizeChange}/>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        </TabPane>
                                        : null
                                    }
                                </Tabs>}
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    let {displaySettings, displaySettingsList, defaultStainSettings} = state.gammaStateReducer
    return{
        preview: state.previewStatusReducer[ownProps.id],
        deviceStatus: state.deviceStatusReducer,
        bloodConfig: state.bloodConfigReducer,
        displaySettings,
        displaySettingsList,
        defaultStainSettings
    }
}

export default connect(mapStateToProps)(GeneralPreviewSettingsComp);